// Node Modules
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Themes
import theme from '@/themes/index';

const Header = ({
  content: {
    title,
    location,
    date,
    timeReading,
  },
}) => {
  return (
    <>
      <div className='header-container'>
        <h5>{title}</h5>
        <div className='info-container'>
          <div className='details-info'>
            <span className='details'>{location} / {moment(date).format('D MMMM YYYY')}</span>
            <span className='reading'>{timeReading}</span>
          </div>
          {/* <div className='share'>
            <FontAwesomeIcon icon={['fa', 'share']} className='share-icon' />
            <a>Share</a>
          </div>*/}
        </div>
        
      </div>
      <style jsx>{`
        div.header-container {
          display: flex;
          flex-direction: column;
          padding-bottom: 4rem;
        }

        div.header-container h5 {
          margin-block-start: 0;
          margin-block-end: 0;
        }

        div.header-container span.reading {
          color: ${theme.fontColors.optional3};
        }

        div.header-container .info-container {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding-top: 1rem;
        }

        div.header-container .info-container .details-info {
          display: flex;
          flex-direction: column;
        }

        div.header-container .info-container .share {
          position: relative;
          display: flex;
        }

        div.header-container .info-container .share a {
          margin-left: 1.2rem;
          color: ${theme.fontColors.optional4};
          text-decoration: underline;
          cursor: pointer;
        }

        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.header-container span.details {
            padding-top: 0.5rem;
          }

          div.header-container .info-container {
            padding-top: 0;
          }
        }
      `}</style>
      <style global jsx>{`
        div.header-container .info-container .share svg.share-icon {
          position: absolute;
          top: 0.375rem;
          font-size: 1.5em;
          color: ${theme.fontColors.optional4};
        }
      `}</style>
    </>
  );
};

export default Header;
